(function() {
  'use strict';

  const permanentDomain = document.body.getAttribute('data-permanent-domain');
  const earnRule = `https://loyalty-app-ovqx.onrender.com/api/earn-rate?shop=${permanentDomain}`;

async function getEarnRates() {
  const response = await fetch(earnRule);
  return response.json();
}

let purchaseRate = 0;

async function initLoyalty() {
  const data = await getEarnRates();
  const currency = window.Shopify?.currency?.active || 'AUD';
  purchaseRate = data.earnRules.purchase_rewards.rates[currency]?.value || 0;
  console.log(data, currency, purchaseRate);
  loyaltyOSM(data, currency);
  
  // Initial cart rewards update
  updateCartRewards();
}

function loyaltyOSM(data, currency) {
  const elements = document.querySelectorAll('.loyalty-app-osm');
  const earnRule = data.earnRules;
  elements.forEach(element => {
      console.log(earnRule)
      const earnRuleRatesAccount = earnRule.account_creation.rates[currency];
      const earnRuleRatesPurchase = earnRule.purchase_rewards.rates[currency];
      if (element.dataset.earnRule === 'account_creation') {
        element.textContent = `$${earnRuleRatesAccount.value}`;
      } else if (element.dataset.earnRule === 'purchase_rewards') {
        element.textContent = `${earnRuleRatesPurchase.formatted}`;
      }
  });
}

async function updateCartRewards(data) {
  const cart = document.querySelector('.loyalty-app-osm-cart');
  if (!cart) return;

    let items_subtotal_price = cart.dataset.cartSubtotal || 0;

    if (data) {
        items_subtotal_price = data.items_subtotal_price;
    }

    console.log(items_subtotal_price, purchaseRate);

    const subtotal = items_subtotal_price / 100;
    const earnRate = subtotal * purchaseRate;
    const displayValue = Number.isInteger(earnRate) ? earnRate : earnRate.toFixed(2);
    
    cart.innerHTML = `You'll earn <strong>$${displayValue}</strong> in loyalty credit on this order`;
}

initLoyalty();

// Listen to Udesly cart-updated event (fired by udesly-shopify.min.js)
if (window.Udesly) {
  Udesly.on('cart-updated', function(data) {
    // Update rewards whenever cart is updated
    updateCartRewards(data);
  });
}

})();